export const OCAMP_TOPIC = 'Ocamp'

export function isOcampTopic(topic) {
  if (!topic) return false
  return String(topic).trim().toLowerCase() === 'ocamp'
}

const HIDDEN_TOPICS = new Set(['一周CP', 'CP'])

export function shouldHideTopic(topic) {
  return HIDDEN_TOPICS.has(topic)
}
